export default "__VITE_IMAGE_ASSET__46ede2d2__";